import { render, staticRenderFns } from "./RegistroFotoCuip.vue?vue&type=template&id=43d33dd8&scoped=true"
import script from "./RegistroFotoCuip.vue?vue&type=script&lang=js"
export * from "./RegistroFotoCuip.vue?vue&type=script&lang=js"
import style0 from "./RegistroFotoCuip.vue?vue&type=style&index=0&id=43d33dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d33dd8",
  null
  
)

export default component.exports